import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DesignComponent } from './design/design.component';

import { DlaComponent } from './dla/dla.component';
import { TntComponent } from './tnt/tnt.component';
import { Kfp3Component } from './kfp3/kfp3.component';
import { TbsComponent } from './tbs/tbs.component';
import { EComponent } from './e/e.component';
import { NoosaComponent } from './noosa/noosa.component';
import { MattelComponent } from './mattel/mattel.component';
import { FoxComponent } from './fox/fox.component';
import { ToyotaComponent } from './toyota/toyota.component';
import { StxComponent } from './stx/stx.component';
import { LovelyComponent } from './lovely/lovely.component';
import { DiscoverComponent } from './discover/discover.component';


const routes: Routes = [

  {
    path: 'design',
    component: DesignComponent,
    children: [
      {path: 'dla', component: DlaComponent},
      {path: 'tnt', component: TntComponent},
      {path: 'kfp3', component: Kfp3Component},
      { path: 'tbs', component: TbsComponent},
      { path: 'e', component: EComponent},
      { path: 'noosa', component: NoosaComponent},
      { path: 'mattel', component: MattelComponent},
      { path: 'fox', component: FoxComponent},
      { path: 'toyota', component: ToyotaComponent},
      { path: 'stx', component: StxComponent},
      { path: 'lovely', component: LovelyComponent},
      { path: 'discover', component: DiscoverComponent },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class DesignRoutingModule {} 